import { PerformanceState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";
import {
  ILabelInfo,
  IPerformance,
  IPerformanceCom,
  IPerformanceSelectOptions,
  IPerfSecondData,
  ITestInfo,
  IReport,
  AddBug,
  IPerformanceDashboard,
  IReportPage,
  IPerformanceAnalysis,
  IPerformanceAovTrend,
  IPerformanceAovEmail,
  AovPerformances,
  LastRecord,
  RecentTaskrecord,
  UploadPerformance,
  UploadTopPerformance,
  UploadTopPerformanceTop,
  TaskRecordQuery,
  TaskRecordDevices,
  AovPerformanceCopy,
  PerfInfo,
  INewReportList,
  IDateVersion,
  ICODMReportDetail,
  ICODMReport,
  ITOPReport,
  ITOPReportDetail,
  ITOPReportTable,
  ITOPReportTableList,
  IXHOOKReportList,
  IXHOOKReport,
  ISmokeReport,
  IDeepPerformanceSelectOptions,
} from "@/interfaces";
import {
  dispatchGetAllPerformances,
  dispatchGetPerformances,
  dispatchGetReportList,
  dispatchLastRecord,
  dispatchGetTOPReportTable,
  dispatchGetTOPReportTableList,
  dispatchGetPerformancePageList,
} from "./actions";
import { store } from "..";

export const mutations = {
  setPerformances(state: PerformanceState, payload: IPerformance[]) {
    state.performances = payload;
  },

  setUploadPerformance(state: PerformanceState, payload: UploadPerformance) {
    state.upload_performance = payload;
  },
  setUploadTopPerformance(state: PerformanceState, payload: UploadTopPerformance) {
    state.upload_top_performance = payload;
  },
  setAddBug(state: PerformanceState, payload: AddBug) {
    state.add_bug = payload;
  },
  setUploadTopPerformanceUpload(state: PerformanceState, payload: any) {
    state.upload_top_performance_load = payload;
  },
  setSetTopTemplates(state: PerformanceState, payload: any) {
    state.top_templates= payload;
  },
  setSetTopBaselines(state: PerformanceState, payload: any) {
    state.top_baselines= payload;
  },
  setSetTopTemplatesData(state: PerformanceState, payload: any) {
    state.top_templates_data= payload;
  },
  setSetTopBaselinesData(state: PerformanceState, payload: any) {
    state.top_baselines_data= payload;
  },
  setAllPerformances(state: PerformanceState, payload: IPerformance[]) {
    state.all_performances = payload;
  },
  setPerformanceTableFields(state: PerformanceState, payload: any) {
    state.performance_table_fields = payload;
  },
  setPerformancePageList(state: PerformanceState, payload: IPerformanceCom) {
    state.performance_page_list = payload;
  },
  setPerformancePageListSummary (state: PerformanceState, payload: IPerformanceCom) {
    state.setPerformancePageListSummary = payload;
  },
  setDeepPerformancePageList(
    state: PerformanceState,
    payload: IPerformanceCom
  ) {
    state.deep_performance_page_list = payload;
  },
  setPerformanceSelectOptions(
    state: PerformanceState,
    payload: IPerformanceSelectOptions
  ) {
    state.performance_select_options = payload;
  },
  setPerformanceCustomVersionList(
    state: PerformanceState,
    payload: any
  ) {
    state.performance_custom_version = payload;
  },
  setDeepPerformanceSelectOptions(
    state: PerformanceState,
    payload: IDeepPerformanceSelectOptions
  ) {
    state.deep_performance_select_options = payload;
  },
  setDeepPerformanceSelectOptionsOld(
    state: PerformanceState,
    payload: IDeepPerformanceSelectOptions
  ) {
    state.deep_performance_select_options_old = payload;
  },
  setDeepPerformanceSelectOptionsLast(
    state: PerformanceState,
    payload: IDeepPerformanceSelectOptions
  ) {
    state.deep_performance_select_options_last= payload;
  },
  setDateVersion(state: PerformanceState, payload: IDateVersion) {
    state.date_versions = payload;
  },
  setTestInfo(state: PerformanceState, payload: ITestInfo[]) {
    state.test_info = payload;
  },
  setLabelInfo(state: PerformanceState, payload: ILabelInfo[]) {
    state.label_info = payload;
  },
  setLabelInfoLabel(state: PerformanceState, payload: any) {
    state.label_info_laebl = payload;
  },
  setPerfInfo(state: PerformanceState, payload: PerfInfo[]) {
    state.perf_info = payload;
  },
  setPerfSecondData(state: PerformanceState, payload: IPerfSecondData) {
    state.cperf_second_data = payload;
  },
  setPerfAvgdData(state: PerformanceState, payload: any) {
    state.avg_data = payload;
  },
  setReports(state: PerformanceState, payload: IReportPage) {
    state.report_list = payload;
  },
  deleteReport(
    state: PerformanceState,
    // payload: { project: number; page: number }
    payload: {
      project: number;
      page: number;
      size: number;
      report_name: string;
      new_version: string;
      old_version: string;
      risk: string;
      creator: string;
    }
  ) {
    dispatchGetReportList(store, {
      project: payload.project,
      page: payload.page,
      size: payload.size,
      report_name: payload.report_name,
      new_version: payload.new_version,
      old_version: payload.old_version,
      risk: payload.risk,
      creator: payload.creator,
    });
    // state.report_list = state.report_list.filter((report: IReport) => report.id !== payload);
  },
  updateReport(
    state: PerformanceState,
    payload: {
      project: number;
      page: number;
      size: number;
      report_name: string;
      new_version: string;
      old_version: string;
      risk: string;
      creator: string;
    }
  ) {
    dispatchGetReportList(store, {
      project: payload.project,
      page: 1,
      size: 16,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
  },
  // updateReport(state: PerformanceState, payload: number) {
  //   dispatchGetReportList(store, { project: payload, page: 1 });
  // },
  setPerfReport(state: PerformanceState, payload: any) {
    state.perf_report = payload;
  },
  setWeaponReport(state: PerformanceState, payload: any) {
    state.weapon_report = payload;
  },
  setNzmReport(state: PerformanceState, payload: any) {
    state.nzm_report = payload;
  },
  setPerfGpuReport(state: PerformanceState, payload: any) {
    state.perf_report_gpu = payload;
  },
  setLiveReport(state: PerformanceState, payload: any) {
    state.live_report = payload;
  },
  setPerfReportIdTest(state: PerformanceState, payload: any) {
    state.perf_report_id_test = payload;
  },
  setStressPerfReport(state: PerformanceState, payload: any) {
    state.stress_perf_report = payload;
  },
  setLabelReport(state: PerformanceState, payload: any) {
    state.label_report = payload;
  },
  setNzmMemoryStackAll(state: PerformanceState, payload: any) {
    state.nzm_memory_stack_all = payload;
  },
  setDeepMemoryData(state: PerformanceState, payload: any) {
    state.deep_memory_data = payload;
  },
  setDeepMemoryDataCread(state: PerformanceState, payload: any) {
    state.deep_memory_data_cread = payload;
  },
  setDeepMemoryDataCreadOld(state: PerformanceState, payload: any) {
    state.deep_memory_data_cread_old = payload;
  },
  setAovCopyPerfToReport(state: PerformanceState, payload: any) {
    state.aov_copy_perf_to_report = payload;
  },
  setNewReport(state: PerformanceState, payload: IReport) {
    state.new_report = payload;
  },
  setNewSmgReport(state: PerformanceState, payload: IReport) {
    state.new_smg_report = payload;
  },

  setNewReportList(state: PerformanceState, payload: INewReportList) {
    state.new_report_list = payload;
  },
  setLiveReportList(state: PerformanceState, payload: INewReportList) {
    state.live_report_list = payload;
  },
  setPerfDashboard(state: PerformanceState, payload: IPerformanceDashboard) {
    state.perf_dashboard = payload;
  },
  setPerfUpdateSkinLineView(
    state: PerformanceState,
    payload: IPerformanceDashboard
  ) {
    state.update_skin_line_view = payload;
  },
  // setDataValid(state: PerformanceState, payload: number) {
  //   dispatchGetPerformancePageList(store, { project: payload});
  // },
  setGetPerformanceAnalysis(
    state: PerformanceState,
    payload: IPerformanceAnalysis
  ) {
    state.performance_analysis = payload;
  },
  setGetPerformanceAovTrend(
    state: PerformanceState,
    payload: IPerformanceAovTrend[]
  ) {
    state.performance_aov_trend = payload;
  },
  setGetAovPerformances(state: PerformanceState, payload: AovPerformances[]) {
    state.aov_performances = payload;
  },
  setTaskRecordQuery(state: PerformanceState, payload: TaskRecordQuery[]) {
    state.task_record_query = payload;
  },
  setTaskRecordDevices(state: PerformanceState, payload: TaskRecordDevices[]) {
    state.task_record_devices = payload;
  },
  setAovPerformanceCopy(
    state: PerformanceState,
    payload: AovPerformanceCopy[]
  ) {
    state.aov_performance_copy = payload;
  },
  setLastRecord(state: PerformanceState, payload: LastRecord) {
    state.last_record = payload;
  },
  setRecentTaskrecord(state: PerformanceState, payload: RecentTaskrecord[]) {
    state.recent_taskrecord = payload;
  },
  setPerformanceAovEmail(
    state: PerformanceState,
    payload: IPerformanceAovEmail
  ) {
    state.performance_aov_email = payload;
  },
  setCODMReport(state: PerformanceState, payload: ICODMReportDetail) {
    state.codm_report = payload;
  },
  setCODMReportList(state: PerformanceState, payload: ICODMReport[]) {
    state.codm_reports = payload;
  },
  deleteCODMReport(state: PerformanceState, payload: number) {
    state.codm_reports = state.codm_reports.filter(
      (report: ICODMReport) => report.id !== payload
    );
  },
  setTOPReportList(state: PerformanceState, payload: ITOPReport[]) {
    state.top_reports = payload;
  },
  setTOPReportDetail(state: PerformanceState, payload: ITOPReport) {
    state.top_report_detail = payload;
  },
  setTOPReport(state: PerformanceState, payload: ITOPReportDetail) {
    state.top_report = payload;
  },
  setTOPReportTable(state: PerformanceState, payload: ITOPReportTable[]) {
    state.top_report_table = payload;
  },
  setTOPReportTableList(state: PerformanceState, payload: ITOPReportTableList) {
    state.top_report_table_list = payload;
  },
  setTOPReportGenerate(state: PerformanceState, payload: ITOPReportTableList) {
    state.top_report_table_generate = payload;
  },
  setXhookReport(state: PerformanceState, payload: IXHOOKReport) {
    state.xhook_report = payload;
  },
  setXhookReportList(state: PerformanceState, payload: IXHOOKReportList[]) {
    state.xhook_report_list = payload;
  },
  setWedoReport(state: PerformanceState, payload: any) {
    state.Wado_report = payload;
  },
  setSkinReport(state: PerformanceState, payload: any) {
    state.Skin_report = payload;
  },
  setSkinReportOption(state: PerformanceState, payload: any) {
    state.Skin_report_option = payload;
  },
  setSkinReportList(state: PerformanceState, payload: any) {
    state.Skin_report_list = payload;
  },
  setSkinReportOptionOld(state: PerformanceState, payload: any) {
    state.Skin_report_option_old = payload;
  },
  setSkinReportWhole(state: PerformanceState, payload: any) {
    state.Skin_report_whole = payload;
  },
  setSkinReportdata(state: PerformanceState, payload: any) {
    state.Skin_report_data = payload;
  },
  setSkinReportComparedata(state: PerformanceState, payload: any) {
    state.Skin_report_compare_data = payload;
  },
  setSkinReportInside(state: PerformanceState, payload: any) {
    state.Skin_report_inside = payload;
  },
  setSmgReport(state: PerformanceState, payload: any) {
    state.smg_report = payload;
  },
  setSkinTableReport(state: PerformanceState, payload: any) {
    state.Skin_report_table = payload;
  },
  setArrange(state: PerformanceState, payload: any) {
    state.arrange = payload;
  },
  setLogDownload(state: PerformanceState, payload: any) {
    state.Log_download = payload;
  },
  setSmokeReport(state: PerformanceState, payload: any) {
    state.Smoke_Report = payload;
  },
  setProtocolReport(state: PerformanceState, payload: any) {
    state.protocol_report= payload;
  },
  setLoginSmokeReport(state: PerformanceState, payload: any) {
    state.Login_Smoke_Report = payload;
  },
  setSmokeReportList(state: PerformanceState, payload: ISmokeReport[]) {
    state.smoke_reports = payload;
  },
  setProtocolList(state: PerformanceState, payload: ISmokeReport[]) {
    state.protocol_list= payload;
  },
  setLoginSmokeReportList(state: PerformanceState, payload: ISmokeReport[]) {
    state.login_smoke_reports = payload;
  },
  setPerformanceVersion(state: PerformanceState, payload: any) {
    state.Performance_version = payload;
  },
  setDeepPerformanceDetails(state: PerformanceState, payload: any) {
    state.deep_performance_details = payload;
  },
  setCaseMonitorList(state: PerformanceState, payload: any) {
    state.case_monitor_list = payload;
  },
  setCaseMonitor(state: PerformanceState, payload: any) {
    state.case_monito = payload;
  },
  setDeepPerformanceStack(state: PerformanceState, payload: any) {
    state.deep_performance_stack = payload;
  },
  setInstantiation(state: PerformanceState, payload: any) {
    state.instantiation = payload;
  },
  setInstantiations(state: PerformanceState, payload: any) {
    state.instantiations = payload;
  },
  setChangeFPSlte(state: PerformanceState, payload: any) {
    state.change_fPS_lte = payload;
  },
  setChangeFPSgte(state: PerformanceState, payload: any) {
    state.change_fPS_gte = payload;
  },
  setPlayerid(state: PerformanceState, payload: any) {
    state.player_id = payload;
  },
  setTaskList(state: PerformanceState, payload: any) {
    state.task_list = payload;
  },

  setDc(state: PerformanceState, payload: any) {
    state.dc = payload;
  },
  setDcReport(state: PerformanceState, payload: any) {
    state.dc_report = payload;
  },
  setDeepScene(state: PerformanceState, payload: any) {
    state.deep_scene = payload;
  },
  setDeepMemreport(state: PerformanceState, payload: any) {
    state.deep_scene_port = payload;
  },
  setDeepSceneOptions(state: PerformanceState, payload: any) {
    state.deep_scene_options = payload;
  },
  setDeepMemoryOptions(state: PerformanceState, payload: any) {
    state.deep_memory_options = payload;
  },
  setDeepMemoryLlmList(state: PerformanceState, payload: any) {
    state.deep_memory_llm_list = payload;
  },
  setDeepMemoryDateOptions(state: PerformanceState, payload: any) {
    state.deep_memory_date_options = payload;
  },
  setDeepMemoryRecordList(state: PerformanceState, payload: any) {
    state.deep_memory_recond_list = payload;
  },
  setDeepMemorySubSceneOptions(state: PerformanceState, payload: any) {
    state.deep_memory_sub_scene_options = payload;
  },
  setDeepMemoryTrend(state: PerformanceState, payload: any) {
    state.deep_memory_trend = payload;
  },
  setDeepMemorySceneOptions(state: PerformanceState, payload: any) {
    state.deep_memory_scene_options = payload;
  },
  setDeepMemoryDownLoad(state: PerformanceState, payload: any) {
    state.deep_memory_download= payload;
  },
  setDeepMemoryReport(state: PerformanceState, payload: any) {
    state.deep_memory_report = payload;
  },
  setDeepUnityMemoryReport(state: PerformanceState, payload: any) {
    state.deep_unity_memory_report = payload;
  },
  setDeepUnityMemoryList(state: PerformanceState, payload: any) {
    state.deep_unity_memory_list = payload;
  },
  setDeepMemoryCircleChart(state: PerformanceState, payload: any) {
    state.deep_memory_circle_chart= payload;
  },
  setDeepMemoryUobject(state: PerformanceState, payload: any) {
    state.deep_uobject= payload;
  },
  setDeepMemoryUobjectTrend(state: PerformanceState, payload: any) {
    state.deep_uobject_trend= payload;
  },
  setMemoryDate(state: PerformanceState, payload: any) {
    state.memory_date= payload;
  },
  setMemoryVersion(state: PerformanceState, payload: any) {
    state.memory_version= payload;
  },
  setMemoryDevice(state: PerformanceState, payload: any) {
    state.memory_device= payload;
  },
  setMemoryDeviceSecond(state: PerformanceState, payload: any) {
    state.memory_device_second= payload;
  },
  setMemoryScene(state: PerformanceState, payload: any) {
    state.memory_scene= payload;
  },
  setMemoryType(state: PerformanceState, payload: any) {
    state.memory_type= payload;
  },
  setMemoryDateVersion(state: PerformanceState, payload: any) {
    state.memory_date_version= payload;
  },
  setMemoryDateVersionNew(state: PerformanceState, payload: any) {
    state.memory_date_version_new= payload;
  },
  setMemoryDateVersionDevice(state: PerformanceState, payload: any) {
    state.memory_date_version_device= payload;
  },
  setObjectMemoryLevel(state: PerformanceState, payload: any) {
    state.memory_level= payload;
  },
  setObjectMemorySceneSecond(state: PerformanceState, payload: any) {
    state.memory_scene_second= payload;
  },
  setObjectMemorymoduleAll(state: PerformanceState, payload: any) {
    state.memory_module_all= payload;
  },
  setObjectMemoryReport(state: PerformanceState, payload: any) {
    state.memory_object_memory_report= payload;
  },
  setObjectMemoryTrend(state: PerformanceState, payload: any) {
    state.memory_object_memory_trend= payload;
  },
  setObjectFunctionTrend(state: PerformanceState, payload: any) {
    state.memory_funtion_trend= payload;
  },
  setObjectFunctionId(state: PerformanceState, payload: any) {
    state.memory_funtion_id= payload;
  },
  setObjectModuleListId(state: PerformanceState, payload: any) {
    state.memory_module_id= payload;
  },
  setObjectFunctionTrendDraw(state: PerformanceState, payload: any) {
    state.memory_funtion_trend_draw= payload;
  },
  setMemoryList(state: PerformanceState, payload: any) {
    state.memory_list= payload;
  },
  setMemoryListData(state: PerformanceState, payload: any) {
    state.memory_list_data= payload;
  },
  setMemoryStackOld(state: PerformanceState, payload: any) {
    state.memory_stack_old= payload;
  },
  setMemoryStack(state: PerformanceState, payload: any) {
    state.memory_stack= payload;
  },
  setMemorySubStack(state: PerformanceState, payload: any) {
    state.memory_sub_stack= payload;
  },
  setMemoryAllStack(state: PerformanceState, payload: any) {
    state.memory_all_stack= payload;
  },
  setMemoryAppointStack(state: PerformanceState, payload: any) {
    state.memory_appoint_stack= payload;
  },
  setMemoryAppointOldLeftStack(state: PerformanceState, payload: any) {
    state.memory_appoint_old_left_stack= payload;
  },
  setMemoryAppointOldRightStack(state: PerformanceState, payload: any) {
    state.memory_appoint_old_right_stack= payload;
  },
  setMemoryAllStackOld(state: PerformanceState, payload: any) {
    state.memory_all_stack_old= payload;
  },
  setMemorySubStackOld(state: PerformanceState, payload: any) {
    state.memory_sub_stack_old= payload;
  },
  setMemoryModuleList(state: PerformanceState, payload: any) {
    state.memory_module_list= payload;
  },
  setMemoryFunctionTrendAll(state: PerformanceState, payload: any) {
    state.memory_function_list_all= payload;
  },
  setMemoryFunctionAppoint(state: PerformanceState, payload: any) {
    state.memory_function_appoint= payload;
  },
  setMemoryFunctionAppointOld(state: PerformanceState, payload: any) {
    state.memory_function_appoint_old= payload;
  },
  setMemoryModuleListSecond(state: PerformanceState, payload: any) {
    state.memory_module_list_second= payload;
  },
  setMemoryModuleListAppoint(state: PerformanceState, payload: any) {
    state.memory_module_list_appoint= payload;
  },
  setMemoryModuleListAppointOld(state: PerformanceState, payload: any) {
    state.memory_module_list_appoint_old= payload;
  },
  setMemoryModuleTrend(state: PerformanceState, payload: any) {
    state.memory_module_trend= payload;
  },
  setMemoryModuleSubTrend(state: PerformanceState, payload: any) {
    state.memory_module_sub_trend= payload;
  },
  setDeepMemreportData(state: PerformanceState, payload: any) {
    state.deep_deepMemreport_data= payload;
  },
  setSkinManagement(state: PerformanceState, payload: any) {
    state.skin_management = payload;
  },
  setSgameSkinOption(state: PerformanceState, payload: any) {
    state.sgame_skin_option = payload;
  },
  setSgameSkinData(state: PerformanceState, payload: any) {
    state.sgame_skin_data = payload;
  },
  setSkinTabListGet(state: PerformanceState, payload: any) {
    state.sgame_skin_list= payload;
  },
  setSkinLinePkg(state: PerformanceState, payload: any) {
    state.skin_pkg = payload;
  },
  setSkinLineDate(state: PerformanceState, payload: any) {
    state.skin_date = payload;
  },
  setTestCase(state: PerformanceState, payload: any) {
    state.test_case = payload;
  },
  setTestCaseList(state: PerformanceState, payload: any) {
    state.test_case_list = payload;
  },
  setSimpleDateOptions(state: PerformanceState, payload: any) {
    state.simple_date_options = payload;
  },
  setLightPerfDate(state: PerformanceState, payload: any) {
    state.light_date_options = payload;
  },
  setAndroidAppDate(state: PerformanceState, payload: any) {
    state.android_app_date_options = payload;
  },
  setLightPerfDateContrast(state: PerformanceState, payload: any) {
    state.light_date_contrast_options = payload;
  },
  setAndroidAppDateContrast(state: PerformanceState, payload: any) {
    state.android_app_date_contrast_options = payload;
  },
  setLightPerfTrend(state: PerformanceState, payload: any) {
    state.light_trend= payload;
  },
  setAndroidAppFileTrend(state: PerformanceState, payload: any) {
    state.android_app_file_trend= payload;
  },
  setLightPerfFunctions(state: PerformanceState, payload: any) {
    state.light_functions= payload;
  },
  setLightPerfUrl(state: PerformanceState, payload: any) {
    state.light_url= payload;
  },
  setAndroidAppFilename(state: PerformanceState, payload: any) {
    state.android_app_filename= payload;
  },
  setAndroidAppFileUrl(state: PerformanceState, payload: any) {
    state.android_app_url= payload;
  },
  setLightPerfDevice(state: PerformanceState, payload: any) {
    state.light_device_options = payload;
  },
  setAndroidAppDevice(state: PerformanceState, payload: any) {
    state.android_app_device_options = payload;
  },
  setAndroidAppZip(state: PerformanceState, payload: any) {
    state.android_app_zip= payload;
  },
  setLightPerfScene(state: PerformanceState, payload: any) {
    state.light_scene_options = payload;
  },
  setAndroidAppScene(state: PerformanceState, payload: any) {
    state.android_app_scene_options = payload;
  },
  setLightResourceCost(state: PerformanceState, payload: any) {
    state.light_resour_cost_options = payload;
  },
  setAndroidAppFileCompare(state: PerformanceState, payload: any) {
    state.android_app_file_compare = payload;
  },
  setLightJankCost(state: PerformanceState, payload: any) {
    state.light_jank_cost_options = payload;
  },
  setLightMethodCost(state: PerformanceState, payload: any) {
    state.light_method_cost_options = payload;
  },
  setLightPerfSubtype(state: PerformanceState, payload: any) {
    state.light_subtype_options = payload;
  },
  setAndroidAppSubtype(state: PerformanceState, payload: any) {
    state.android_app_subtype_options = payload;
  },
  setLightPerfLog(state: PerformanceState, payload: any) {
    state.light_log_options = payload;
  },
  setAndroidAppLog(state: PerformanceState, payload: any) {
    state.android_app_log_options = payload;
  },
  setAbdDateOptions(state: PerformanceState, payload: any) {
    state.abd_date_options = payload;
  },
  setPkgResourceDate(state: PerformanceState, payload: any) {
    state.pkg_resource_date = payload;
  },
  setPkgResourceDevice(state: PerformanceState, payload: any) {
    state.pkg_resource_device = payload;
  },
  setPkgResourceScenes(state: PerformanceState, payload: any) {
    state.pkg_resource_scene = payload;
  },
  setPkgResourceList(state: PerformanceState, payload: any) {
    state.pkg_resource_list = payload;
  },
  setPkgResourceReport(state: PerformanceState, payload: any) {
    state.pkg_resource_report = payload;
  },
  setPkgResourceListOld(state: PerformanceState, payload: any) {
    state.pkg_resource_list_old = payload;
  },
  setPkgResourceListThreadOld(state: PerformanceState, payload: any) {
    state.pkg_resource_list_thread_old = payload;
  },
  setPkgTypeList(state: PerformanceState, payload: any) {
    state.pkg_type_list = payload;
  },
  setPkgResourceSum(state: PerformanceState, payload: any) {
    state.pkg_resource_sum = payload;
  },
  setPkgResourceTrend(state: PerformanceState, payload: any) {
    state.pkg_resource_trend = payload;
  },
  setPkgAssetTrend(state: PerformanceState, payload: any) {
    state.pkg_asset_trend = payload;
  },
  setPkgStructTrend(state: PerformanceState, payload: any) {
    state.pkg_struct_trend = payload;
  },
  setPkgAbnormalTrend(state: PerformanceState, payload: any) {
    state.pkg_abnorma_trend = payload;
  },
  setPkgMapStructTrend(state: PerformanceState, payload: any) {
    state.pkg_map_struct_trend = payload;
  },
  setDeepPerformanceCpuLabels(state: PerformanceState, payload: any) {
    state.deep_cpu_labels = payload;
  },
  setDeepPerformanceCpuUsageTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_usage_trend = payload;
  },
  setDeepPerformanceCpuLabelsOld(state: PerformanceState, payload: any) {
    state.deep_cpu_labels_old = payload;
  },
  setDeepPerformanceCpuPerfTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_perf_trend= payload;
  },
  setDeepPerformanceCpuCustomTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_custom_trend= payload;
  },
  setDeepPerformanceCpuVersions(state: PerformanceState, payload: any) {
    state.deep_cpu_versions = payload;
  },
  setDeepPerformanceCpufuncTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_func_trend= payload;
  },
  setDeepPerformanceCpuConfig(state: PerformanceState, payload: any) {
    state.deep_cpu_config = payload;
  },
  setDeepPerformanceCpuConfigSoList(state: PerformanceState, payload: any) {
    state.deep_cpu_config_so_list = payload;
  },
  setDeepPerformanceCpuFunctionCos(state: PerformanceState, payload: any) {
    state.deep_cpu_function_cos = payload;
  },
  setDeepPerformanceTrendNode(state: PerformanceState, payload: any) {
    state.deep_cpu_trend_node = payload;
  },
  setDeepPerformanceCpuFunctionModel(state: PerformanceState, payload: any) {
    state.deep_cpu_function_model = payload;
  },
  setDeepPerformanceCpuStack(state: PerformanceState, payload: any) {
    state.deep_cpu_stack = payload;
  },
  setDeepPerformanceCpuStackMerge(state: PerformanceState, payload: any) {
    state.deep_cpu_stack_merge = payload;
  },
  setDeepPerformanceCpuStackFind(state: PerformanceState, payload: any) {
    state.deep_cpu_stack_find = payload;
  },
  setDeepPerformanceFrameProblem(state: PerformanceState, payload: any) {
    state.deep_frame_problem = payload;
  },
  setDeepPerformanceAvgStack(state: PerformanceState, payload: any) {
    state.deep_avg_stack = payload;
  },
  setTokenLibraryList(state: PerformanceState, payload: any) {
    state.token_library_list = payload;
  },
  setDeepPerformanceCpuStackCreated(state: PerformanceState, payload: any) {
    state.deep_cpu_stack_creat = payload;
  },
  setDeepPerformanceCpuStackCreatedOld(state: PerformanceState, payload: any) {
    state.deep_cpu_stack_creat_old = payload;
  },
  setDeepPerformanceCpuDetail(state: PerformanceState, payload: any) {
    state.deep_cpu_detail = payload;
  },
  setDeepPerformanceCputhreadByFrame(state: PerformanceState, payload: any) {
    state.deep_cpu_thread_by_frame = payload;
  },
  setDeepPerformanceCatonList(state: PerformanceState, payload: any) {
    state.deep_caton_list = payload;
  },
  setDeepPerformanceCpuVersionsOld(state: PerformanceState, payload: any) {
    state.deep_cpu_versions_old = payload;
  },
  setDeepPerformanceCpuPutDetail(state: PerformanceState, payload: any) {
    state.deep_cpu_put_detail = payload;
  },
  setDeepPerformanceSimpleDetail(state: PerformanceState, payload: any) {
    state.deep_simple_put_detail = payload;
  },
  setDeepPerformanceCpuPutCheck(state: PerformanceState, payload: any) {
    state.deep_cpu_put_check = payload;
  },
  setDeepPerformanceCpuFunction(state: PerformanceState, payload: any) {
    state.deep_cpu_function = payload;
  },
  setDeepPerformanceCpuFunctionOverview(state: PerformanceState, payload: any) {
    state.deep_cpu_function_overview = payload;
  },
  setDeepPerformanceCpuThreadList(state: PerformanceState, payload: any) {
    state.deep_cpu_thread_list = payload;
  },
  setDeepPerformanceCpuCustomData(state: PerformanceState, payload: any) {
    state.deep_cpu_custom_data= payload;
  },
  setDeepPerformanceCpuUsageList(state: PerformanceState, payload: any) {
    state.deep_cpu_usage_list= payload;
  },
  setDeepPerformanceCpuUsageListQQ(state: PerformanceState, payload: any) {
    state.deep_cpu_usage_list_qq= payload;
  },
  setDeepPerformanceCpuUsageModuleQQ(state: PerformanceState, payload: any) {
    state.deep_cpu_usage_list_moudule_qq= payload;
  },
  setDeepPerformanceCpuReport(state: PerformanceState, payload: any) {
    state.deep_cpu_report= payload;
  },
  setDeepPerformancefuncList(state: PerformanceState, payload: any) {
    state.deep_func_list= payload;
  },
  setDeepPerformanceCpuByFrame(state: PerformanceState, payload: any) {
    state.deep_cpu_by_frame = payload;
  },
  setDeepPerformanceFpsInsideTrend(state: PerformanceState, payload: any) {
    state.deep_fps_inside_trend = payload;
  },
  setDeepPerformanceCpuThreads(state: PerformanceState, payload: any) {
    state.deep_cpu_threads = payload;
  },
  setDeepPerformanceFlameGraphUrl(state: PerformanceState, payload: any) {
    state.deep_flame_url = payload;
  },
  setDeepPerformanceCpuTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_trend = payload;
  },
  setDeepPerformanceCpuThreadTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_thread_trend = payload;
  },
  setDeepPerformanceCpuSoTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_so_trend = payload;
  },
  setDeepPerformanceCpuModuleTrend(state: PerformanceState, payload: any) {
    state.deep_cpu_module_trend = payload;
  },
  setPkgTypeListOld(state: PerformanceState, payload: any) {
    state.pkg_type_list_old = payload;
  },
  setPkgTypeTable(state: PerformanceState, payload: any) {
    state.pkg_type_table = payload;
  },
  setPkgTypeRate(state: PerformanceState, payload: any) {
    state.pkg_type_rate = payload;
  },
  setPkgAssetStack(state: PerformanceState, payload: any) {
    state.pkg_asset_stack = payload;
  },
  setPkgAssetType(state: PerformanceState, payload: any) {
    state.pkg_asset_type = payload;
  },
  setPkgStructStack(state: PerformanceState, payload: any) {
    state.pkg_struct_stack = payload;
  },
  setSpeedmMemoryList(state: PerformanceState, payload: any) {
    state.speedm_memory_list = payload;
  },
  setSpeedmMemoryConfig(state: PerformanceState, payload: any) {
    state.speedm_memory_config = payload;
  },
  setMemSummartList(state: PerformanceState, payload: any) {
    state.mem_summary_list = payload;
  },
  setMemSummaryTrend(state: PerformanceState, payload: any) {
    state.mem_summary_trend = payload;
  },
  setMemSummaryTrendiOS(state: PerformanceState, payload: any) {
    state.mem_summary_trend_ios = payload;
  },
  setMemDateVersions(state: PerformanceState, payload: any) {
    state.mem_date_versions = payload;
  },
  setMemSummartListV1(state: PerformanceState, payload: any) {
    state.mem_summary_list_v1 = payload;
  },
  setResourceScanDates(state: PerformanceState, payload: any) {
    state.resource_dates = payload;
  },
  setResourceScanCarList(state: PerformanceState, payload: any) {
    state.resource_car_list = payload;
  },
  setResourceScanLoadList(state: PerformanceState, payload: any) {
    state.resource_load_list = payload;
  },
  setResourceScanSkinList(state: PerformanceState, payload: any) {
    state.resource_skin_list = payload;
  },
  setResourceOverall(state: PerformanceState, payload: any) {
    state.resource_overall = payload;
  },
  setResourceAverageData(state: PerformanceState, payload: any) {
    state.resource_average_data = payload;
  },
  setResourceScanChart(state: PerformanceState, payload: any) {
    state.resource_average_chart= payload;
  },
  setResourceHistory(state: PerformanceState, payload: any) {
    state.resource_history= payload;
  },
  setResourceScanChartAvg(state: PerformanceState, payload: any) {
    state.resource_average_chart_avg= payload;
  },
  setResourceScanTypeList(state: PerformanceState, payload: any) {
    state.resource_scan_type_list= payload;
  },
  setResourceScanCarData(state: PerformanceState, payload: any) {
    state.resource_car_data= payload;
  },
  setResourceScanRecords(state: PerformanceState, payload: any) {
    state.resource_records = payload;
  },
  setResourceScanVersions(state: PerformanceState, payload: any) {
    state.resource_versions = payload;
  },
  setResourceScanDevices(state: PerformanceState, payload: any) {
    state.resource_devices = payload;
  },
  setResourceScanScenes(state: PerformanceState, payload: any) {
    state.resource_scenes = payload;
  },
  setResourceScanId(state: PerformanceState, payload: any) {
    state.resource_id= payload;
  },
  setSpeedmMemoryScens(state: PerformanceState, payload: any) {
    state.speedm_memory_scenes = payload;
  },
  setSpeedmMemoryRecords(state: PerformanceState, payload: any) {
    state.speedm_memory_records = payload;
  },
  setSpeedmMemoryFilenameList(state: PerformanceState, payload: any) {
    state.speedm_memory_filename_list = payload;
  },
  setSpeedmMemorySourceList(state: PerformanceState, payload: any) {
    state.speedm_memory_source_list = payload;
  },
  setSpeedmMemorySourceFilesList(state: PerformanceState, payload: any) {
    state.speedm_memory_source_file_list = payload;
  },
  setSpeedmModSummary(state: PerformanceState, payload: any) {
    state.speedm_mod_summary = payload;
  },
  setSpeedmModSummaryV1(state: PerformanceState, payload: any) {
    state.speedm_mod_summary_v1 = payload;
  },
  setSpeedmMemoryResSummary(state: PerformanceState, payload: any) {
    state.speedm_memory_res_summary = payload;
  },
  setSpeedmModList(state: PerformanceState, payload: any) {
    state.speedm_mod_list = payload;
  },
  setSpeedmModResList(state: PerformanceState, payload: any) {
    state.speedm_mod_res_list = payload;
  },
  setSpeedmMemoryResTrend(state: PerformanceState, payload: any) {
    state.speedm_memory_res_trend= payload;
  },
  setSpeedmResSummaryList(state: PerformanceState, payload: any) {
    state.speedm_summary_list= payload;
  },
  setSpeedmModTrend(state: PerformanceState, payload: any) {
    state.speedm_mod_trend= payload;
  },
  setSpeedmMemorySummary(state: PerformanceState, payload: any) {
    state.speedm_memory_summary = payload;
  },
  setSpeedmMemoryTrend(state: PerformanceState, payload: any) {
    state.speedm_memory_trend = payload;
  },
  setPkgMapStructStack(state: PerformanceState, payload: any) {
    state.pkg_map_struct_stack = payload;
  },
  setPkgMapStructStackList(state: PerformanceState, payload: any) {
    state.pkg_map_struct_stack_list= payload;
  },
  setPkgMapStructStackOption(state: PerformanceState, payload: any) {
    state.pkg_map_struct_stack_option = payload;
  },
  setPkgAssetStackFind(state: PerformanceState, payload: any) {
    state.pkg_asset_stack_find = payload;
  },
  setSmokeByReport(state: PerformanceState, payload: any) {
    state.smoke_by_report = payload;
  },
  setLightSmokeScenes(state: PerformanceState, payload: any) {
    state.light_smoke_scene = payload;
  },
  setLightSmokeVersions(state: PerformanceState, payload: any) {
    state.light_smoke_version = payload;
  },
  setLightCommonKey(state: PerformanceState, payload: any) {
    state.light_common_key= payload;
  },
  setLightCommonUrl(state: PerformanceState, payload: any) {
    state.light_common_url= payload;
  },
  setLightSmokeDevices(state: PerformanceState, payload: any) {
    state.light_smoke_devices = payload;
  },
  setLightSmokeTodDevices(state: PerformanceState, payload: any) {
    state.light_smoke_tod_devices = payload;
  },
  setLightSmokeList(state: PerformanceState, payload: any) {
    state.light_smoke_list= payload;
  },
  setSimpleTaskOptions(state: PerformanceState, payload: any) {
    state.simple_task_options = payload;
  },
  setSimpleTable(state: PerformanceState, payload: any) {
    state.simple_table = payload;
  },
  setSimpleTypeOptions(state: PerformanceState, payload: any) {
    state.simple_type_options = payload;
  },
  setSimpleProcessOptions(state: PerformanceState, payload: any) {
    state.simple_process_options = payload;
  },
  setSimpleThreadOptions(state: PerformanceState, payload: any) {
    state.simple_thread_options = payload;
  },
  setSimpleLog(state: PerformanceState, payload: any) {
    state.simple_log = payload;
  },
  setSimpleSoOptions(state: PerformanceState, payload: any) {
    state.simple_so_options = payload;
  },
  setSimpleLabelOptions(state: PerformanceState, payload: any) {
    state.simple_label_options = payload;
  },
  setCpuFuncDeivces(state: PerformanceState, payload: any) {
    state.cpu_deivce_options = payload;
  },
  setCpuTrend(state: PerformanceState, payload: any) {
    state.cpu_trend= payload;
  },
  setCpuFuncScenes(state: PerformanceState, payload: any) {
    state.cpu_scene_options = payload;
  },
  commitSimpleUrl(state: PerformanceState, payload: any) {
    state.simple_url= payload;
  },
  setAbdDeviceOptions(state: PerformanceState, payload: any) {
    state.abd_device_options = payload;
  },
  setSimpleDeviceOptions(state: PerformanceState, payload: any) {
    state.simple_device_options = payload;
  },
  setSimpleReportOptions(state: PerformanceState, payload: any) {
    state.simple_report_options = payload;
  },
  setSimpleVersionOptions(state: PerformanceState, payload: any) {
    state.simple_version_options = payload;
  },
  setSimpleVersionOptionsOld(state: PerformanceState, payload: any) {
    state.simple_version_options_old = payload;
  },
  setSimpleTrendParams(state: PerformanceState, payload: any) {
    state.simple_trend_params = payload;
  },
  setSimpleTotalTrend(state: PerformanceState, payload: any) {
    state.simple_total_params = payload;
  },
  setSimpleSceneOptions(state: PerformanceState, payload: any) {
    state.simple_scene_options = payload;
  },
  setSimpleSubtypeOptions(state: PerformanceState, payload: any) {
    state.simple_subtype_options = payload;
  },
  setAbdSceneOptions(state: PerformanceState, payload: any) {
    state.abd_scene_options = payload;
  },
  setAbdSubtypeOptions(state: PerformanceState, payload: any) {
    state.abd_subtype_options = payload;
  },
  setAbdList(state: PerformanceState, payload: any) {
    state.abd_list = payload;
  },
  setAbdDateSingle(state: PerformanceState, payload: any) {
    state.abd_date_single = payload;
  },
  setAbdCompare(state: PerformanceState, payload: any) {
    state.abd_compare = payload;
  },
  setAbdProcessCompare(state: PerformanceState, payload: any) {
    state.abd_process_compare = payload;
  },
  setAbdType(state: PerformanceState, payload: any) {
    state.abd_type = payload;
  },
  setLightResource(state: PerformanceState, payload: any) {
    state.light_resource = payload;
  },
  setAndroidAppFileData(state: PerformanceState, payload: any) {
    state.android_app_file_data = payload;
  },
  setLightJank(state: PerformanceState, payload: any) {
    state.light_jank = payload;
  },
  setLightMethod(state: PerformanceState, payload: any) {
    state.light_method = payload;
  },
  setAbdSum(state: PerformanceState, payload: any) {
    state.abd_sum = payload;
  },
  setAbdLog(state: PerformanceState, payload: any) {
    state.abd_log = payload;
  },
  setAbdUrl(state: PerformanceState, payload: any) {
    state.abd_url = payload;
  },
  setAbdProcess(state: PerformanceState, payload: any) {
    state.abd_Process = payload;
  },
  setMemoryResouceSpeedOptions(state: PerformanceState, payload: any) {
    state.memory_resouce_speed_options = payload;
  },
  setMemoryResouceVehicle(state: PerformanceState, payload: any) {
    state.memory_resouce_vehice = payload;
  },
  setSimpleData(state: PerformanceState, payload: any) {
    state.simple_data = payload;
  },
  setSimpleByData(state: PerformanceState, payload: any) {
    state.simple_by_data = payload;
  },
  setAndroidOfflineDate(state: PerformanceState, payload: any) {
    state.android_offline_date = payload;
  },
  setPerfettoOptions(state: PerformanceState, payload: any) {
    state.perfetto_options = payload;
  },
  setPerfettoTypeOptions(state: PerformanceState, payload: any) {
    state.perfetto_type_options = payload;
  },
  setXcodeTypeOptions(state: PerformanceState, payload: any) {
    state.xcode_type_options = payload;
  },
  setXcodeDateOptions(state: PerformanceState, payload: any) {
    state.xcode_date_options = payload;
  },
  setXcodeDeviceOptions(state: PerformanceState, payload: any) {
    state.xcode_device_options = payload;
  },
  setXcodeDimensOptions(state: PerformanceState, payload: any) {
    state.xcode_dimens_options = payload;
  },
  setXcodeLevelOptions(state: PerformanceState, payload: any) {
    state.xcode_level_options = payload;
  },
  setXcodeSceneOptions(state: PerformanceState, payload: any) {
    state.xcode_scene_options = payload;
  },
  setPerfettoSettings(state: PerformanceState, payload: any) {
    state.perfetto_settings = payload;
  },
  setPerformanceSvgLog(state: PerformanceState, payload: any) {
    state.performance_svg_log = payload;
  },
  setPerformanceDsLog(state: PerformanceState, payload: any) {
    state.performance_ds_log = payload;
  },
  setPerformanceSvgLogData(state: PerformanceState, payload: any) {
    state.performance_svg_log_data = payload;
  },
  setPerformanceDsLogData(state: PerformanceState, payload: any) {
    state.performance_ds_log_data = payload;
  },
  setPerfettoOptionsOld(state: PerformanceState, payload: any) {
    state.perfetto_options_old = payload;
  },
  setPerfettoOldOptions(state: PerformanceState, payload: any) {
    state.perfetto_old_date= payload;
  },
  setPerfettoDownLoadStack(state: PerformanceState, payload: any) {
    state.perfetto_down_stack = payload;
  },
  setPerfettoDeviceOptions(state: PerformanceState, payload: any) {
    state.perfetto_device_options = payload;
  },
  setPerfettoDeviceOptionsTrend(state: PerformanceState, payload: any) {
    state.perfetto_device_options_trend = payload;
  },
  setPerfettoDeviceOptionsImportant(state: PerformanceState, payload: any) {
    state.perfetto_device_options_important = payload;
  },
  setPerfettoLevelOptions(state: PerformanceState, payload: any) {
    state.perfetto_level_options = payload;
  },
  setPerfettoStack(state: PerformanceState, payload: any) {
    state.perfetto_Stack = payload;
  },
  setXcodeStack(state: PerformanceState, payload: any) {
    state.xcode_Stack = payload;
  },
  setPerfettoStackSearch(state: PerformanceState, payload: any) {
    state.perfetto_Stack_search = payload;
  },
  setPerfettoStackSearchV2(state: PerformanceState, payload: any) {
    state.perfetto_Stack_search_v2 = payload;
  },
  setPerfettoStackSearchSo(state: PerformanceState, payload: any) {
    state.perfetto_Stack_search_so = payload;
  },
  setPerfettoStackSearchFuncitons(state: PerformanceState, payload: any) {
    state.perfetto_Stack_search_functions = payload;
  },
  setPerfettoLevelOptionsImportant(state: PerformanceState, payload: any) {
    state.perfetto_level_options_important = payload;
  },
  setPerfettoSceneOptions(state: PerformanceState, payload: any) {
    state.perfetto_scene_options = payload;
  },
  setPerfettoNativeTrend(state: PerformanceState, payload: any) {
    state.perfetto_native_trend= payload;
  },
  setXcodeoNativeTrend(state: PerformanceState, payload: any) {
    state.xcode_native_trend= payload;
  },
  setPerfettoNativeFuncTrend(state: PerformanceState, payload: any) {
    state.perfetto_native_func_trend= payload;
  },
  setXcodeNativeFuncTrend(state: PerformanceState, payload: any) {
    state.xcode_native_func_trend= payload;
  },
  setPerfettoSoFuncTrend(state: PerformanceState, payload: any) {
    state.perfetto_so_func_trend= payload;
  },
  setXcodeSoFuncTrend(state: PerformanceState, payload: any) {
    state.xcode_so_func_trend= payload;
  },
  setPerfettoNativeModule(state: PerformanceState, payload: any) {
    state.perfetto_native_module= payload;
  },
  setPerfettoSoList(state: PerformanceState, payload: any) {
    state.perfetto_so_list= payload;
  },
  setPerfettoModuleTrend(state: PerformanceState, payload: any) {
    state.perfetto_module_trend= payload;
  },
  setPerfettoModuleList(state: PerformanceState, payload: any) {
    state.perfetto_module_list= payload;
  },
  setXcodeSoList(state: PerformanceState, payload: any) {
    state.xcode_so_list= payload;
  },
  setPerfettoNativeAll(state: PerformanceState, payload: any) {
    state.perfetto_native_all= payload;
  },
  setXcodeNativeAll(state: PerformanceState, payload: any) {
    state.xcode_native_all= payload;
  },
  setXcodeNativeModule(state: PerformanceState, payload: any) {
    state.xcode_native_module= payload;
  },
  setPerfettoSoAll(state: PerformanceState, payload: any) {
    state.perfetto_so_all= payload;
  },
  setXcodeSoAll(state: PerformanceState, payload: any) {
    state.xcode_so_all= payload;
  },
  setObjectFuncAll(state: PerformanceState, payload: any) {
    state.object_func_all= payload;
  },
  setPerfettoReport(state: PerformanceState, payload: any) {
    state.perfetto_report = payload;
  },
  setXcodeReport(state: PerformanceState, payload: any) {
    state.xcode_report = payload;
  },
  setAndroidOfflineOldDate(state: PerformanceState, payload: any) {
    state.android_offline_date_old = payload;
  },
  setAndroidOfflineDevice(state: PerformanceState, payload: any) {
    state.android_offline_device= payload;
  },
  setAndroidOfflineScenes(state: PerformanceState, payload: any) {
    state.android_offline_scenes= payload;
  },
  setAndroidOfflineSubtypes(state: PerformanceState, payload: any) {
    state.android_offline_subtypes= payload;
  },
  setAndroidOfflineList(state: PerformanceState, payload: any) {
    state.android_offline_list= payload;
  },
  setAndroidOfflineOldList(state: PerformanceState, payload: any) {
    state.android_offline_old_list= payload;
  },
  setAndroidOfflineThreadOldList(state: PerformanceState, payload: any) {
    state.android_offline_thread_old_list= payload;
  },
  setAndroidThreadOptions(state: PerformanceState, payload: any) {
    state.android_thread_options= payload;
  },
  setAndroidThreadCompare(state: PerformanceState, payload: any) {
    state.android_thread_compare= payload;
  },
  setAndroidCourseCompare(state: PerformanceState, payload: any) {
    state.android_course_compare= payload;
  },
  setAndroidCourseOptions(state: PerformanceState, payload: any) {
    state.android_course_options= payload;
  },
  setAndroidOfflineZip(state: PerformanceState, payload: any) {
    state.android_offline_zip= payload;
  },
  setAndroidOfflineUrl(state: PerformanceState, payload: any) {
    state.android_offline_url= payload;
  },
  setAndroidCourseTrend(state: PerformanceState, payload: any) {
    state.android_course_trend= payload;
  },
  setAndroidThreadTrend(state: PerformanceState, payload: any) {
    state.android_thread_trend= payload;
  },
  setAndroidCourseProcessList(state: PerformanceState, payload: any) {
    state.android_course_process_list= payload;
  },
  setAndroidThreadProcessList(state: PerformanceState, payload: any) {
    state.android_thread_process_list= payload;
  },
  setDeepPerformanceCpuFuncReport(state: PerformanceState, payload: any) {
    state.deep_cpu_func_report= payload;
  },
  setCaseControl(state: PerformanceState, payload: any) {
    state.case_control = payload;
  },
  setSkinLineView(state: PerformanceState, payload: any) {
    state.skin_line_viewt = payload;
  },
  setDeepSceneVedio(state: PerformanceState, payload: any) {
    state.deep_scene_vedio = payload;
  },
  setDeepSceneOld(state: PerformanceState, payload: any) {
    state.deep_scene_old = payload;
  },
  setDeepSceneOldVedio(state: PerformanceState, payload: any) {
    state.deep_scene_old_vedio = payload;
  },
  setDeepFind(state: PerformanceState, payload: any) {
    state.deep_find = payload;
  },
};

const { commit } = getStoreAccessors<PerformanceState, State>("");
export const commitSetPerformances = commit(mutations.setPerformances);
export const commitSetUploadPerformance = commit(
  mutations.setUploadPerformance
);
export const commitSetUploadTopPerformance = commit(
  mutations.setUploadTopPerformance
);
export const commitSetAddBug = commit(
  mutations.setAddBug 
);
export const commitSetUploadTopPerformanceUpload = commit(
  mutations.setUploadTopPerformanceUpload
);
export const commitSetTopTemplates = commit(
  mutations.setSetTopTemplates
);
export const commitSetTopBaselines = commit(
  mutations.setSetTopBaselines
);
export const commitSetTopTemplatesData = commit(
  mutations.setSetTopTemplatesData
);
export const commitSetTopBaselinesData = commit(
  mutations.setSetTopBaselinesData
);
export const commitSetAllPerformances = commit(mutations.setAllPerformances);
export const commitSetPerformanceTableFields = commit(
  mutations.setPerformanceTableFields
);
export const commitSetPerformancePageList = commit(
  mutations.setPerformancePageList
);
export const commitSetPerformancePageListSummary = commit(
  mutations.setPerformancePageListSummary
);
export const commitSetDeepPerformancePageList = commit(
  mutations.setDeepPerformancePageList
);
export const commitSetPerformanceSelectOptions = commit(
  mutations.setPerformanceSelectOptions
);
export const commitSetPerformanceCustomVersionList = commit(
  mutations.setPerformanceCustomVersionList 
);
export const commitSetDeepPerformanceSelectOptions = commit(
  mutations.setDeepPerformanceSelectOptions
);
export const commitSetDeepPerformanceSelectOptionsOld = commit(
  mutations.setDeepPerformanceSelectOptionsOld
);
export const commitSetDeepPerformanceSelectOptionsLast = commit(
  mutations.setDeepPerformanceSelectOptionsLast 
);
export const commitSetDateVersion = commit(mutations.setDateVersion);
export const commitSetTestInfo = commit(mutations.setTestInfo);
export const commitSetLabelInfo = commit(mutations.setLabelInfo);
export const commitSetLabelInfoLabel = commit(mutations.setLabelInfoLabel);
export const commitSetPerfInfo = commit(mutations.setPerfInfo);
export const commitSetPerfSecondData = commit(mutations.setPerfSecondData);
export const commitSetPerfAvgdData = commit(mutations.setPerfAvgdData);
export const commitSetNewReport = commit(mutations.setNewReport);
export const commitSetNewSmgReport = commit(mutations.setNewSmgReport);
export const commitSetNzmMemoryStackAll = commit(
  mutations.setNzmMemoryStackAll
);
export const commitSetDeepMemoryData = commit(
  mutations.setDeepMemoryData
);
export const commitSetDeepMemoryDataCread = commit(
  mutations.setDeepMemoryDataCread
);
export const commitSetDeepMemoryDataCreadOld = commit(
  mutations.setDeepMemoryDataCreadOld
);
export const commitNewReportList = commit(mutations.setNewReportList);
export const commitLiveReportList = commit(mutations.setLiveReportList);
export const commitSetReports = commit(mutations.setReports);
export const commitSetPerfReport = commit(mutations.setPerfReport);
export const commitSetWeaponReport = commit(mutations.setWeaponReport);
export const commitSetNzmReport = commit(mutations.setNzmReport);
export const commitSetPerfGpuReport = commit(mutations.setPerfGpuReport);
export const commitSetLiveReport = commit(mutations.setLiveReport);
export const commitSetPerfReportIdTest = commit(mutations.setPerfReportIdTest);
export const commitSetStressPerfReport = commit(mutations.setStressPerfReport);
export const commitSetLabelReport = commit(mutations.setLabelReport);
export const commitSetAovCopyPerfToReport = commit(
  mutations.setAovCopyPerfToReport
);
export const commitSetPerfDashboard = commit(mutations.setPerfDashboard);
export const commitSetUpdateSkinLineView = commit(
  mutations.setPerfUpdateSkinLineView
);
export const commitDeleteReport = commit(mutations.deleteReport);
export const commitUpdateReport = commit(mutations.updateReport);
// export const commitDataValid = commit(mutations.setDataValid);
export const commitsetGetPerformanceAnalysis = commit(
  mutations.setGetPerformanceAnalysis
);
export const commitGetPerformanceAovTrend = commit(
  mutations.setGetPerformanceAovTrend
);
export const commitPerformanceAovEmail = commit(
  mutations.setPerformanceAovEmail
);
export const commitGetAovPerformances = commit(mutations.setGetAovPerformances);
export const commitTaskRecordQuery = commit(mutations.setTaskRecordQuery);
export const commitTaskRecordDevices = commit(mutations.setTaskRecordDevices);
export const commitAovPerformanceCopy = commit(mutations.setAovPerformanceCopy);
export const commitLastRecord = commit(mutations.setLastRecord);
export const commitRecentTaskrecord = commit(mutations.setRecentTaskrecord);
export const commitSetCODMReport = commit(mutations.setCODMReport);
export const commitSetCODMReportList = commit(mutations.setCODMReportList);
export const commitDeleteCODMReport = commit(mutations.deleteCODMReport);
export const commitSetTOPReportList = commit(mutations.setTOPReportList);
export const commitSetTOPReportDetail = commit(mutations.setTOPReportDetail);
export const commitSetTOPReport = commit(mutations.setTOPReport);
export const commitSetTOPReportTable = commit(mutations.setTOPReportTable);
export const commitSetTOPReportTableList = commit(
  mutations.setTOPReportTableList
);
export const commitSetTOPReportGenerate = commit(
  mutations.setTOPReportGenerate
);
export const commitSetXhookReportList = commit(mutations.setXhookReportList);

export const commitSetXhookReport = commit(mutations.setXhookReport);
export const commitSetWedoReport = commit(mutations.setWedoReport);
export const commitSetSkinReport = commit(mutations.setSkinReport);
export const commitSetSkinReportOption = commit(mutations.setSkinReportOption);
export const commitSetSkinReportList = commit(mutations.setSkinReportList);
export const commitSetSkinReportOptionOld = commit(mutations.setSkinReportOptionOld);
export const commitSetSkinReportWhole = commit(mutations.setSkinReportWhole);
export const commitSetSkinReportdata = commit(mutations.setSkinReportdata);
export const commitSetSkinReportComparedata = commit(mutations.setSkinReportComparedata );
export const commitSetSmokeReport = commit(mutations.setSmokeReport);
export const commitSetProtocolReport = commit(mutations.setProtocolReport);
export const commitSetLoginSmokeReport = commit(mutations.setLoginSmokeReport );
export const commitSetSmokeReportList = commit(mutations.setSmokeReportList);
export const commitSetProtocolList = commit(mutations.setProtocolList );
export const commitSetLoginSmokeReportList = commit(mutations.setLoginSmokeReportList);
export const commitSetSkinReportInside = commit(mutations.setSkinReportInside);
export const commitSetSmgReport = commit(mutations.setSmgReport);
export const commitSetSkinTableReport = commit(mutations.setSkinTableReport);
export const commitSetArrange = commit(mutations.setArrange);
export const commitSetLogDownload = commit(mutations.setLogDownload);
export const commitSetPerformanceVersion = commit(
  mutations.setPerformanceVersion
);
export const commitSetDeepPerformanceDetails = commit(
  mutations.setDeepPerformanceDetails
);
export const commitSetCaseMonitorList = commit(
  mutations.setCaseMonitorList
);
export const commitSetCaseMonitor = commit(
  mutations.setCaseMonitor
);
export const commitSetDeepPerformanceStack = commit(
  mutations.setDeepPerformanceStack
);
export const commitSetInstantiation = commit(mutations.setInstantiation);
export const commitSetInstantiations = commit(mutations.setInstantiations);
export const commitSetChangeFPSlte = commit(mutations.setChangeFPSlte);
export const commitSetChangeFPSgte = commit(mutations.setChangeFPSgte);
export const commitSetPlayerid = commit(mutations.setPlayerid);
export const commitSetTaskList = commit(mutations.setTaskList);

export const commitSetDC = commit(mutations.setDc);
export const commitSetDcReport = commit(mutations.setDcReport);
export const commitSetDeepScene = commit(mutations.setDeepScene);
export const commitSetDeepMemreport = commit(mutations.setDeepMemreport);
export const commitSetDeepSceneOptions = commit(mutations.setDeepSceneOptions);
export const commitSetMemoryOptions = commit(mutations.setDeepMemoryOptions);
export const commitSetMemoryLlmList = commit(mutations.setDeepMemoryLlmList);
export const commitSetMemoryDateOptions = commit(mutations.setDeepMemoryDateOptions);
export const commitSetMemoryRecordList = commit(mutations.setDeepMemoryRecordList);
export const commitSetMemorySubSceneOptions = commit(mutations.setDeepMemorySubSceneOptions);
export const commitSetMemoryTrend = commit(mutations.setDeepMemoryTrend);
export const commitSetMemorySceneOptions = commit(mutations.setDeepMemorySceneOptions);
export const commitSetMemoryDownLoad = commit(mutations.setDeepMemoryDownLoad );
export const commitSetMemoryReport = commit(mutations.setDeepMemoryReport);
export const commitSetUnityMemoryReport = commit(mutations.setDeepUnityMemoryReport );
export const commitSetUnityMemoryList = commit(mutations.setDeepUnityMemoryList );
export const commitSetMemoryCircleChar = commit(mutations.setDeepMemoryCircleChart);
export const commitSetMemoryUobject = commit(mutations.setDeepMemoryUobject );
export const commitSetMemoryUobjectTrend = commit(mutations.setDeepMemoryUobjectTrend);
export const commitSetMemoryDate = commit(mutations.setMemoryDate);
export const commitSetMemoryVersion = commit(mutations.setMemoryVersion);
export const commitSetMemoryDevice = commit(mutations.setMemoryDevice);
export const commitSetMemoryDeviceSecond = commit(mutations.setMemoryDeviceSecond);
export const commitSetMemoryScene = commit(mutations.setMemoryScene);
export const commitSetMemoryType = commit(mutations.setMemoryType);
export const commitSetMemoryDateVersion = commit(mutations.setMemoryDateVersion );
export const commitSetMemoryDateVersionNew = commit(mutations.setMemoryDateVersionNew );
export const commitSetMemoryDateVersionDevice = commit(mutations.setMemoryDateVersionDevice  );
export const commitSetObjectMemoryLevel = commit(mutations.setObjectMemoryLevel );
export const commitSetObjectMemorySceneSecond = commit(mutations.setObjectMemorySceneSecond  );
export const commitSetObjectMemorymoduleAll = commit(mutations.setObjectMemorymoduleAll   );
export const commitSetObjectMemoryReport = commit(mutations.setObjectMemoryReport );
export const commitSetObjectMemoryTrend = commit(mutations.setObjectMemoryTrend );
export const commitSetObjectFunctionTrend = commit(mutations.setObjectFunctionTrend );
export const commitSetObjectFunctionId = commit(mutations.setObjectFunctionId );
export const commitSetObjectMemoryModuleListId = commit(mutations.setObjectModuleListId );
export const commitSetObjectFunctionTrendDraw = commit(mutations.setObjectFunctionTrendDraw  );
export const commitSetMemoryList = commit(mutations.setMemoryList);
export const commitSetMemoryListData = commit(mutations.setMemoryListData );
export const commitSetMemoryStackOld = commit(mutations.setMemoryStackOld);
export const commitSetMemoryStack = commit(mutations.setMemoryStack);
export const commitSetMemorySubStack = commit(mutations.setMemorySubStack);
export const commitSetMemoryAllStack = commit(mutations.setMemoryAllStack);
export const commitSetMemoryAppointStack = commit(mutations.setMemoryAppointStack);
export const commitSetMemoryAppointOldLeftStack = commit(mutations.setMemoryAppointOldLeftStack);
export const commitSetMemoryAppointOldRightStack = commit(mutations.setMemoryAppointOldRightStack);
export const commitSetMemoryAllStackOld = commit(mutations.setMemoryAllStackOld);
export const commitSetMemorySubStackOld = commit(mutations.setMemorySubStackOld);
export const commitSetMemoryModuleList = commit(mutations.setMemoryModuleList );
export const commitSetMemoryFunctionTrendAll = commit(mutations.setMemoryFunctionTrendAll );
export const commitSetMemoryFunctionAppoint = commit(mutations.setMemoryFunctionAppoint);
export const commitSetMemoryFunctionAppointOld = commit(mutations.setMemoryFunctionAppointOld);
export const commitSetMemoryModuleListSecond = commit(mutations.setMemoryModuleListSecond  );
export const commitSetMemoryModuleListAppoint = commit(mutations.setMemoryModuleListAppoint );
export const commitSetMemoryModuleListAppointOld = commit(mutations.setMemoryModuleListAppointOld  );
export const commitSetMemorModuleTrend = commit(mutations.setMemoryModuleTrend );
export const commitSetMemorModuleSubTrend = commit(mutations.setMemoryModuleSubTrend  );
export const commitSetMemreportData = commit(mutations.setDeepMemreportData);
export const commitSetSkinLinePkg = commit(mutations.setSkinLinePkg);
export const commitSetSkinLineDate = commit(mutations.setSkinLineDate);
export const commitSetSkinManagement = commit(mutations.setSkinManagement);
export const commitSetSgameSkinOption = commit(mutations.setSgameSkinOption);
export const commitSetSgameSkinData = commit(mutations.setSgameSkinData );
export const commitSetSkinTabListGet = commit(mutations.setSkinTabListGet );
export const commitSetSkinLineView = commit(mutations.setSkinLineView);
export const commitSetDeepSceneVedio = commit(mutations.setDeepSceneVedio);
export const commitSetDeepSceneOld = commit(mutations.setDeepSceneOld);
export const commitSetDeepSceneOldVedio = commit(
  mutations.setDeepSceneOldVedio
);
export const commitSetDeepFind = commit(mutations.setDeepFind);
export const commitSetTestCase = commit(mutations.setTestCase);
export const commitSetTestCaseList = commit(mutations.setTestCaseList);
export const commitCaseControl = commit(mutations.setCaseControl);
export const commitSimpleDateOptions = commit(mutations.setSimpleDateOptions);
export const commitLightPerfDate = commit(mutations.setLightPerfDate);
export const commitAndroidAppDate = commit(mutations.setAndroidAppDate);
export const commitLightPerfDateContrast = commit(mutations.setLightPerfDateContrast);
export const commitAndroidAppDateContrast = commit(mutations.setAndroidAppDateContrast );
export const commitLightPerfTrend = commit(mutations.setLightPerfTrend);
export const commitAndroidAppFileTrend = commit(mutations.setAndroidAppFileTrend);
export const commitLightPerfFunctions = commit(mutations.setLightPerfFunctions );
export const commitLightPerfUrl = commit(mutations.setLightPerfUrl );
export const commitAndroidAppFilename = commit(mutations.setAndroidAppFilename );
export const commitAndroidAppFileUrl = commit(mutations.setAndroidAppFileUrl);
export const commitLightPerfDevice = commit(mutations.setLightPerfDevice);
export const commitAndroidAppDevice = commit(mutations.setAndroidAppDevice );
export const commitAndroidAppZip = commit(mutations.setAndroidAppZip );
export const commitLightPerfScene = commit(mutations.setLightPerfScene);
export const commitAndroidAppScene = commit(mutations.setAndroidAppScene);
export const commitLightPerfResourceCost = commit(mutations.setLightResourceCost);
export const commitAndroidAppFileCompare = commit(mutations.setAndroidAppFileCompare);
export const commitLightPerfJankCost = commit(mutations.setLightJankCost);
export const commitLightPerfMethodCost = commit(mutations.setLightMethodCost);
export const commitLightPerfSubtype = commit(mutations.setLightPerfSubtype);
export const commitAndroidAppSubtype = commit(mutations.setAndroidAppSubtype);
export const commitLightPerfLog = commit(mutations.setLightPerfLog);
export const commitAndroidAppLog = commit(mutations.setAndroidAppLog);
export const commitAbdDateOptions = commit(mutations.setAbdDateOptions);
export const commitPkgResourceDate = commit(mutations.setPkgResourceDate);
export const commitPkgResourceDevice = commit(mutations.setPkgResourceDevice);
export const commitPkgResourceScenes = commit(mutations.setPkgResourceScenes);
export const commitPkgResourceList = commit(mutations.setPkgResourceList );
export const commitPkgResourceReport = commit(mutations.setPkgResourceReport  );
export const commitPkgResourceListOld = commit(mutations.setPkgResourceListOld  );
export const commitPkgResourceListThreadOld = commit(mutations.setPkgResourceListThreadOld  );
export const commitPkgTypeList = commit(mutations.setPkgTypeList );
export const commitPkgResourceSum = commit(mutations.setPkgResourceSum );
export const commitPkgResourceTrend = commit(mutations.setPkgResourceTrend );
export const commitPkgAssetTrend = commit(mutations.setPkgAssetTrend  );
export const commitPkgStructTrend = commit(mutations.setPkgStructTrend );
export const commitPkgAbnormalTrend = commit(mutations.setPkgAbnormalTrend );
export const commitPkgMapStructTrend = commit(mutations.setPkgMapStructTrend  );
export const commitDeepPerformanceCpuLabels = commit(mutations.setDeepPerformanceCpuLabels  );
export const commitDeepPerformanceCpuUsageTrend = commit(mutations.setDeepPerformanceCpuUsageTrend);
export const commitDeepPerformanceCpuLabelsOld = commit(mutations.setDeepPerformanceCpuLabelsOld  );
export const commitDeepPerformanceCpuPerfTrend = commit(mutations.setDeepPerformanceCpuPerfTrend );
export const commitDeepPerformanceCpuCustomTrend = commit(mutations.setDeepPerformanceCpuCustomTrend );
export const commitDeepPerformanceCpuVersions = commit(mutations.setDeepPerformanceCpuVersions );
export const commitDeepPerformanceCpufuncTrend = commit(mutations.setDeepPerformanceCpufuncTrend );
export const commitDeepPerformanceCpuConfig = commit(mutations.setDeepPerformanceCpuConfig );
export const commitDeepPerformanceCpuConfigSoList = commit(mutations.setDeepPerformanceCpuConfigSoList );
export const commitDeepPerformanceCpuFunctionCos = commit(mutations.setDeepPerformanceCpuFunctionCos );
export const commitDeepPerformanceTrendNode = commit(mutations.setDeepPerformanceTrendNode  );
export const commitDeepPerformanceCpuFunctionModel = commit(mutations.setDeepPerformanceCpuFunctionModel);
export const commitDeepPerformanceCpuStack = commit(mutations.setDeepPerformanceCpuStack);
export const commitDeepPerformanceCpuStackMerge = commit(mutations.setDeepPerformanceCpuStackMerge);
export const commitDeepPerformanceCpuStackFind = commit(mutations.setDeepPerformanceCpuStackFind);
export const commitDeepPerformanceFrameProblem = commit(mutations.setDeepPerformanceFrameProblem);
export const commitDeepPerformanceAvgStack = commit(mutations.setDeepPerformanceAvgStack);
export const commitTokenLibraryList = commit(mutations.setTokenLibraryList);
export const commitDeepPerformanceCpuStackCreated = commit(mutations.setDeepPerformanceCpuStackCreated);
export const commitDeepPerformanceCpuStackCreatedOld = commit(mutations.setDeepPerformanceCpuStackCreatedOld);
export const commitDeepPerformanceCpuDetail = commit(mutations.setDeepPerformanceCpuDetail);
export const commitDeepPerformanceCputhreadByFrame = commit(mutations.setDeepPerformanceCputhreadByFrame);
export const commitDeepPerformanceCatonList = commit(mutations.setDeepPerformanceCatonList);
export const commitDeepPerformanceCpuVersionsOld = commit(mutations.setDeepPerformanceCpuVersionsOld );
export const commitSetDeepPerformanceCpuPutDetail = commit(mutations.setDeepPerformanceCpuPutDetail  );
export const commitSetDeepPerformanceSimpleDetail = commit(mutations.setDeepPerformanceSimpleDetail );
export const commitSetDeepPerformanceCpuPutCheck = commit(mutations.setDeepPerformanceCpuPutCheck   );
export const commitDeepPerformanceCpuFunction = commit(mutations.setDeepPerformanceCpuFunction );
export const commitDeepPerformanceCpuFunctionOverview = commit(mutations.setDeepPerformanceCpuFunctionOverview );
export const commitDeepPerformanceCpuThreadList = commit(mutations.setDeepPerformanceCpuThreadList );
export const commitDeepPerformanceCpuCustomData = commit(mutations.setDeepPerformanceCpuCustomData  );
export const commitDeepPerformanceCpuUsageList = commit(mutations.setDeepPerformanceCpuUsageList  );
export const commitDeepPerformanceCpuUsageListQQ = commit(mutations.setDeepPerformanceCpuUsageListQQ  );
export const commitDeepPerformanceCpuUsageListModuleQQ = commit(mutations.setDeepPerformanceCpuUsageModuleQQ );
export const commitDeepPerformanceCpuReport = commit(mutations.setDeepPerformanceCpuReport) ;
export const commitDeepPerformancefuncList = commit(mutations.setDeepPerformancefuncList  );
export const commitDeepPerformanceCpuByFrame = commit(mutations.setDeepPerformanceCpuByFrame );
export const commitDeepPerformanceCpuThreads = commit(mutations.setDeepPerformanceCpuThreads  );
export const commitDeepPerformanceFpsInsideTrend = commit(mutations.setDeepPerformanceFpsInsideTrend );
export const commitDeepPerformancFlameGraphUrl = commit(mutations.setDeepPerformanceFlameGraphUrl );
export const commitDeepPerformanceCpuTrend = commit(mutations.setDeepPerformanceCpuTrend  );
export const commitDeepPerformanceCpuThreadTrend = commit(mutations.setDeepPerformanceCpuThreadTrend  );
export const commitDeepPerformanceCpuSoTrend = commit(mutations.setDeepPerformanceCpuSoTrend);
export const commitDeepPerformanceCpuModuleTrend = commit(mutations.setDeepPerformanceCpuModuleTrend);
export const commitPkgTypeListOld = commit(mutations.setPkgTypeListOld );
export const commitPkgTypeTable = commit(mutations.setPkgTypeTable );
export const commitPkgTypeRate = commit(mutations.setPkgTypeRate  );
export const commitPkgAssetStack = commit(mutations.setPkgAssetStack );
export const commitPkgAssetType = commit(mutations.setPkgAssetType );
export const commitPkgStructStack = commit(mutations.setPkgStructStack );
export const commitSpeedmMemoryList = commit(mutations.setSpeedmMemoryList );
export const commitSpeedmMemoryConfig = commit(mutations.setSpeedmMemoryConfig);
export const commitMemSummartList = commit(mutations.setMemSummartList);
export const commitMemSummaryTrend = commit(mutations.setMemSummaryTrend);
export const commitMemSummaryTrendiOS = commit(mutations.setMemSummaryTrendiOS);
export const commitMemDateVersions = commit(mutations.setMemDateVersions);
export const commitMemSummartListV1 = commit(mutations.setMemSummartListV1);
export const commitResourceScanDates = commit(mutations.setResourceScanDates );
export const commitResourceScanCarList = commit(mutations.setResourceScanCarList);
export const commitResourceScanLoadList = commit(mutations.setResourceScanLoadList);
export const commitResourceScanSkinList = commit(mutations.setResourceScanSkinList);
export const commitResourceOverall = commit(mutations.setResourceOverall);
export const commitResourceScanAverageData = commit(mutations.setResourceAverageData);
export const commitResourceScanChart = commit(mutations.setResourceScanChart);
export const commitResourceHistory = commit(mutations.setResourceHistory );
export const commitResourceScanChartAvg = commit(mutations.setResourceScanChartAvg);
export const commitResourceScanTypeList = commit(mutations.setResourceScanTypeList);
export const commitResourceScanCarData = commit(mutations.setResourceScanCarData );
export const commitResourceRecords = commit(mutations.setResourceScanRecords);
export const commitResourceVersions = commit(mutations.setResourceScanVersions);
export const commitResourceDevices = commit(mutations.setResourceScanDevices );
export const commitResourceScenes = commit(mutations.setResourceScanScenes );
export const commitResourceId = commit(mutations.setResourceScanId );
export const commitSpeedmMemoryScens = commit(mutations.setSpeedmMemoryScens );
export const commitSpeedmMemoryRecords = commit(mutations.setSpeedmMemoryRecords);
export const commitSpeedmFilenameList = commit(mutations.setSpeedmMemoryFilenameList  );
export const commitSpeedmSourceList = commit(mutations.setSpeedmMemorySourceList );
export const commitSpeedmSourceFilesList = commit(mutations.setSpeedmMemorySourceFilesList);
export const commitSpeedmModSummary = commit(mutations.setSpeedmModSummary  );
export const commitSpeedmModSummaryV1 = commit(mutations.setSpeedmModSummaryV1  );
export const commitSpeedmMemoryResSummary = commit(mutations.setSpeedmMemoryResSummary  );
export const commitSpeedmModList = commit(mutations.setSpeedmModList);
export const commitSpeedmModResList = commit(mutations.setSpeedmModResList);
export const commitSpeedmMemoryResTrend = commit(mutations.setSpeedmMemoryResTrend );
export const commitSpeedmResSummaryList = commit(mutations.setSpeedmResSummaryList);
export const commitSpeedmModTrend = commit(mutations.setSpeedmModTrend );
export const commitSpeedmMemorySummary = commit(mutations.setSpeedmMemorySummary  );
export const commitSpeedmMemoryTrend = commit(mutations.setSpeedmMemoryTrend );
export const commitPkgMapStructStack = commit(mutations.setPkgMapStructStack );
export const commitPkgMapStructStackList = commit(mutations.setPkgMapStructStackList );
export const commitPkgMapStructStackOption = commit(mutations.setPkgMapStructStackOption );
export const commitPkgAssetStackFind = commit(mutations.setPkgAssetStackFind);
export const commitSmokeByReport = commit(mutations.setSmokeByReport);
export const commitLightSmokeScenes = commit(mutations.setLightSmokeScenes);
export const commitLightSmokeVersions = commit(mutations.setLightSmokeVersions );
export const commitLightCommonKey = commit(mutations.setLightCommonKey);
export const commitLightCommonUrl = commit(mutations.setLightCommonUrl );
export const commitLightSmokeDevices = commit(mutations.setLightSmokeDevices);
export const commitLightSmokeTodDevices = commit(mutations.setLightSmokeTodDevices);
export const commitLightSmokeList = commit(mutations.setLightSmokeList);
export const commitSimpleTaskOptions = commit(mutations.setSimpleTaskOptions);
export const commitSimpleTable = commit(mutations.setSimpleTable);
export const commitSimpleProcessOptions = commit(mutations.setSimpleProcessOptions);
export const commitSimpleThreadOptions = commit(mutations.setSimpleThreadOptions);
export const commitSimpleLog = commit(mutations.setSimpleLog);
export const commitSimpleSoOptions = commit(mutations.setSimpleSoOptions);
export const commitSimpleTypeOptions = commit(mutations.setSimpleTypeOptions);
export const commitSimpleLabelOptions = commit(mutations.setSimpleLabelOptions);
export const commitCpuFuncDeivces = commit(mutations.setCpuFuncDeivces);
export const commitCpuTrend = commit(mutations.setCpuTrend);
export const commitCpuFuncScenes = commit(mutations.setCpuFuncScenes);
export const commitSimpleUrl = commit(mutations.commitSimpleUrl);
export const commitAbdDeviceptions = commit(mutations.setAbdDeviceOptions);
export const commitSimpleDeviceOptions = commit(mutations.setSimpleDeviceOptions);
export const commitSimpleReportOptions = commit(mutations.setSimpleReportOptions);
export const commitSimpleVersionOptions = commit(mutations.setSimpleVersionOptions);
export const commitSimpleVersionOptionsOld = commit(mutations.setSimpleVersionOptionsOld);
export const commitSimpleTrendParams = commit(mutations.setSimpleTrendParams);
export const commitSimpleTotalTrend = commit(mutations.setSimpleTotalTrend);
export const commitSimpleSceneOptions = commit(mutations.setSimpleSceneOptions);
export const commitSimpleSubtypeOptions = commit(mutations.setSimpleSubtypeOptions);
export const commitAbdSceneOptions = commit(mutations.setAbdSceneOptions);
export const commitAbdSubtypeOptions = commit(mutations.setAbdSubtypeOptions);
export const commitAbdList = commit(mutations.setAbdList);
export const commitAbdDateSingle = commit(mutations.setAbdDateSingle);
export const commitAbdCompare = commit(mutations.setAbdCompare);
export const commitAbdProcessCompare = commit(mutations.setAbdProcessCompare);
export const commitAbdType = commit(mutations.setAbdType);
export const commitLightResource = commit(mutations.setLightResource);
export const commitAndroidAppFileData = commit(mutations.setAndroidAppFileData);
export const commitLightJank = commit(mutations.setLightJank);
export const commitLightMethod = commit(mutations.setLightMethod);
export const commitAbdProcess = commit(mutations.setAbdProcess);
export const commitMemoryResouceSpeedOptions = commit(mutations.setMemoryResouceSpeedOptions);
export const commitMemoryResouceVehicle = commit(mutations.setMemoryResouceVehicle );
export const commitSimpleData = commit(mutations.setSimpleData);
export const commitAbdSum = commit(mutations.setAbdSum);
export const commitAbdLog = commit(mutations.setAbdLog);
export const commitAbdUrl = commit(mutations.setAbdUrl);
export const commitSimpleByData = commit(mutations.setSimpleByData);
export const commitAndroidOfflineDate = commit(mutations.setAndroidOfflineDate);
export const commitPerfettoOptions = commit(mutations.setPerfettoOptions );
export const commitPerfettoTypeOptions = commit(mutations.setPerfettoTypeOptions );
export const commitXcodeTypeOptions = commit(mutations.setXcodeTypeOptions );
export const commitXcodeDateOptions = commit(mutations.setXcodeDateOptions );
export const commitXcodeDeviceOptions = commit(mutations.setXcodeDeviceOptions );
export const commitXcodeDimensOptions = commit(mutations.setXcodeDimensOptions );
export const commitXcodeLevelOptions = commit(mutations.setXcodeLevelOptions );
export const commitXcodeSceneOptions = commit(mutations.setXcodeSceneOptions );
export const commitPerfettoSettings = commit(mutations.setPerfettoSettings );
export const commitPerformanceSvgLog = commit(mutations.setPerformanceSvgLog);
export const commitPerformanceDsLog = commit(mutations.setPerformanceDsLog );
export const commitPerformanceSvgLogData = commit(mutations.setPerformanceSvgLogData );
export const commitPerformanceDsLogData = commit(mutations.setPerformanceDsLogData  );
export const commitPerfettoOptionsOld = commit(mutations.setPerfettoOptionsOld  );
export const commitPerfettoOldOptions = commit(mutations.setPerfettoOldOptions  );
export const commitPerfettoDownLoadStack = commit(mutations.setPerfettoDownLoadStack );
export const commitPerfettoDeviceOptions = commit(mutations.setPerfettoDeviceOptions);
export const commitPerfettoDeviceOptionsTrend = commit(mutations.setPerfettoDeviceOptionsTrend);
export const commitPerfettoDeviceOptionsImportant = commit(mutations.setPerfettoDeviceOptionsImportant );
export const commitPerfettoLevelOptions = commit(mutations.setPerfettoLevelOptions);
export const commitPerfettoStack= commit(mutations.setPerfettoStack);
export const commitXcodeStack= commit(mutations.setXcodeStack);
export const commitPerfettoStackSearch= commit(mutations.setPerfettoStackSearch);
export const commitPerfettoStackSearchV2= commit(mutations.setPerfettoStackSearchV2);
export const commitPerfettoStackSearchSo= commit(mutations.setPerfettoStackSearchSo);
export const commitPerfettoStackSearchFuncitons= commit(mutations.setPerfettoStackSearchFuncitons);
export const commitPerfettoLevelOptionsImportant = commit(mutations.setPerfettoLevelOptionsImportant);
export const commitPerfettoSceneOptions = commit(mutations.setPerfettoSceneOptions);
export const commitPerfettoNativeTrend = commit(mutations.setPerfettoNativeTrend);
export const commitXcodeNativeTrend = commit(mutations.setXcodeoNativeTrend);
export const commitPerfettoNativeFuncTrend = commit(mutations.setPerfettoNativeFuncTrend);
export const commitXcodeNativeFuncTrend = commit(mutations.setXcodeNativeFuncTrend);
export const commitPerfettoSoFuncTrend = commit(mutations.setPerfettoSoFuncTrend );
export const commitXcodeSoFuncTrend = commit(mutations.setXcodeSoFuncTrend );
export const commitPerfettoNativeModule = commit(mutations.setPerfettoNativeModule);
export const commitPerfettoSoList = commit(mutations.setPerfettoSoList);
export const commitPerfettoModuleTrend = commit(mutations.setPerfettoModuleTrend);
export const commitPerfettoModuleList = commit(mutations.setPerfettoModuleList);
export const commitXcodeSoList = commit(mutations.setXcodeSoList);
export const commitPerfettoNativeAll = commit(mutations.setPerfettoNativeAll );
export const commitXcodeNativeModule = commit(mutations.setXcodeNativeModule);
export const commitXcodeNativeAll = commit(mutations.setXcodeNativeAll  );
export const commitPerfettoSoAll = commit(mutations.setPerfettoSoAll );
export const commitXcodeSoAll = commit(mutations.setXcodeSoAll  );
export const commitObjectFuncAll = commit(mutations.setObjectFuncAll  );
export const commitPerfettoReport = commit(mutations.setPerfettoReport);
export const commitXcodeReport = commit(mutations.setXcodeReport);
export const commitAndroidOfflineeDevice = commit(mutations.setAndroidOfflineDevice);
export const commitAndroidOfflineeScenes = commit(mutations.setAndroidOfflineScenes);
export const commitAndroidOfflineeSubtypes = commit(mutations.setAndroidOfflineSubtypes);
export const commitAndroidOfflineeList = commit(mutations.setAndroidOfflineList);
export const commitAndroidOfflineOldDate = commit(mutations.setAndroidOfflineOldDate);
export const commitAndroidOfflineeOldList = commit(mutations.setAndroidOfflineOldList);
export const commitAndroidOfflineeThreadOldList = commit(mutations.setAndroidOfflineThreadOldList);
export const commitAndroidThreadOptions = commit(mutations.setAndroidThreadOptions);
export const commitAndroidThreadCompare = commit(mutations.setAndroidThreadCompare);
export const commitAndroidCourseCompare = commit(mutations.setAndroidCourseCompare);
export const commitAndroidCourseOptions = commit(mutations.setAndroidCourseOptions);
export const commitAndroidOfflineZip = commit(mutations.setAndroidOfflineZip);
export const commitAndroidOfflineUrl = commit(mutations.setAndroidOfflineUrl );
export const commitAndroidCourseTrend = commit(mutations.setAndroidCourseTrend);
export const commitAndroidThreadTrend = commit(mutations.setAndroidThreadTrend);
export const commitAndroidCourseProcessList = commit(mutations.setAndroidCourseProcessList);
export const commitAndroidThreadProcessList = commit(mutations.setAndroidThreadProcessList);
export const commitDeepPerformanceCpuFuncReport = commit(mutations.setDeepPerformanceCpuFuncReport);
